<template>
  <div class="mbo-scene mbo-post">
    <div class="mbo-post__plate">
      <header class="mbo-post__head">
        <div v-for="side in sides" :key="side.camp" :class="['mbo-post__team', 'is-camp' + side.camp, {'is-win': side.win}]">
          <span class="mbo-post__logo">
            <img v-if="side.logo" :src="side.logo" alt="">
            <span v-else>{{ side.short }}</span>
          </span>
          <span class="mbo-post__name"><MbFitText :text="side.name" :max="48" :min="22"/></span>
          <span v-if="side.win" class="mbo-post__win">Победа</span>
        </div>
        <div class="mbo-post__score">
          <small>{{ caption }}</small>
          <b><i class="is-camp1">{{ sides[0].kills }}</i> : <i class="is-camp2">{{ sides[1].kills }}</i></b>
          <small v-if="hasSeries">Счёт серии {{ sides[0].wins }} – {{ sides[1].wins }}</small>
        </div>
      </header>

      <div class="mbo-post__objs">
        <span v-for="o in objectives" :key="o.key">{{ o.title }} <b>{{ o.blue }} : {{ o.red }}</b></span>
      </div>

      <div class="mbo-post__tables">
        <table v-for="side in sides" :key="side.camp" :class="'is-camp' + side.camp">
          <thead>
            <tr>
              <th>{{ side.name }}</th>
              <th class="is-icons">Закл. · эмблема</th>
              <th class="is-num">K / D / A</th>
              <th class="is-num">Золото</th>
              <th class="is-num">Урон</th>
              <th class="is-icons">Предметы</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in side.rows" :key="row.id" :class="{'is-mvp': row.mvp}">
              <td>
                <span class="mbo-post__player">
                  <MbOverlayHero :hero="row.hero"/>
                  <span class="mbo-post__nick">
                    <b>{{ row.nick }}</b>
                    <small>{{ row.hero ? row.hero.name : '—' }}</small>
                  </span>
                  <span v-if="row.mvp" class="mbo-post__mvp">MVP</span>
                </span>
              </td>
              <td class="is-icons">
                <span class="mbo-post__icons">
                  <span class="mbo-post__icon"><MbOverlayIcon :entry="row.spell" :admin="admin"/></span>
                  <span class="mbo-post__icon"><MbOverlayIcon :entry="row.emblem" :admin="admin"/></span>
                </span>
              </td>
              <td class="is-num">{{ row.kda }}</td>
              <td class="is-num">{{ row.gold }}</td>
              <td class="is-num">{{ row.damage }}</td>
              <td class="is-icons">
                <span class="mbo-post__icons">
                  <span v-for="(item, k) in row.items" :key="k" class="mbo-post__icon">
                    <MbOverlayIcon :entry="item" :admin="admin"/>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MbFitText from '@/components/MlbbBroadcast/overlay/MbFitText.vue'
import MbOverlayHero from '@/components/MlbbBroadcast/overlay/MbOverlayHero.vue'
import MbOverlayIcon from '@/components/MlbbBroadcast/overlay/MbOverlayIcon.vue'
import {
  campByNumber,
  campLogoUrl,
  campPlayers,
  campShortName,
  campTeamName,
  formatGameTime,
  formatNumber,
  playerEmblem,
  playerHero,
  playerItems,
  playerName,
  playerSpell,
  seriesScore,
} from '@/common/mlbbBroadcast'
import {formatGold, gameNumber} from '@/common/mlbbOverlay'

const OBJECTIVES = [
  ['kill_tortoise', 'Черепахи'],
  ['kill_lord', 'Лорды'],
  ['kill_tower', 'Башни'],
  ['total_money', 'Золото'],
]

// Макета итогов нет — временная вёрстка, пока дизайнер не пришлёт свою
export default {
  name: 'MbScenePost',
  components: {MbFitText, MbOverlayHero, MbOverlayIcon},
  props: {
    battle: {type: Object, required: true},
    series: {type: Array, default: () => []},
    admin: {type: Boolean, default: false},
  },
  computed: {
    hasSeries() {
      return this.series.length > 1
    },
    caption() {
      const n = gameNumber(this.series, this.battle.id)
      return `${n ? `Игра ${n} · ` : ''}${formatGameTime(this.battle.game_time)}`
    },
    sides() {
      const score = seriesScore(this.series)
      return [1, 2].map((n) => {
        const camp = campByNumber(this.battle, n) || {camp: n}
        return {
          camp: n,
          name: campTeamName(camp),
          short: campShortName(camp).slice(0, 2),
          logo: campLogoUrl(camp),
          kills: formatNumber(camp.score || 0),
          win: this.battle.win_camp === n,
          wins: score[camp.group_team_id] || 0,
          rows: campPlayers(this.battle, n).map((p) => ({
            id: p.id || p.pos,
            nick: playerName(p).name,
            hero: playerHero(p),
            spell: playerSpell(p),
            emblem: playerEmblem(p),
            items: playerItems(p),
            mvp: !!p.is_mvp,
            kda: `${p.kills || 0} / ${p.deaths || 0} / ${p.assists || 0}`,
            gold: formatNumber(p.gold || 0),
            damage: formatGold(p.total_damage),
          })),
        }
      })
    },
    objectives() {
      const [blue, red] = [1, 2].map((n) => campByNumber(this.battle, n) || {})
      return OBJECTIVES.map(([key, title]) => {
        const fmt = key === 'total_money' ? formatGold : (v) => formatNumber(v || 0)
        return {key, title, blue: fmt(blue[key]), red: fmt(red[key])}
      })
    },
  },
}
</script>
